import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  background-color: white;
  margin-top: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  border-radius: 10px;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  width: 100%;
`;

export const WrapperRight = styled(Wrapper)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 10px;
`;

export const WrapperLeft = styled(Wrapper)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;
